import { ChevronRight } from 'lucide-react';
import moment from 'moment';
import { LocationLink } from 'components/LocationLink';
import { PORTAL_ROUTES } from 'utils/constants';
import { formatDate } from 'utils/helpers';
import { CARD, CHIP, LABEL } from './helper';

const Header = ({ appointments, selectedId, onSelect }) => {
  return (
    <div className={`${CARD} px-4 py-3`}>
      <div className="flex items-center justify-between gap-3">
        <p className={LABEL}>
          Upcoming Visits
        </p>

        <LocationLink
          to={PORTAL_ROUTES.APPOINTMENTS}
          className="inline-flex items-center gap-1 text-xs font-semibold text-secondary-900 hover:text-teamcare-blue transition-colors"
        >
          View all
          <ChevronRight size={14} />
        </LocationLink>
      </div>

      {appointments.length === 0 ? (
        <p className="text-xs text-secondary-400 mt-3">No upcoming visits.</p>
      ) : (
        <div role="tablist" className="flex flex-wrap items-center gap-2 mt-3">
          {appointments.map(({ attributes }) => (
            <button
              key={attributes.encoded_id}
              role="tab"
              aria-selected={attributes.encoded_id === selectedId}
              onClick={() => onSelect(attributes.encoded_id)}
              className={`${CHIP} ${
                attributes.encoded_id === selectedId
                  ? 'bg-secondary-800 text-white'
                  : 'bg-secondary-100 text-secondary-900 hover:bg-secondary-200'
              }`}
            >
              {formatDate(moment.parseZone(attributes.appointment_at), 'MMM D')}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default Header;
